import React from 'react'
import Hero from './Hero'

function SupportPage() {
    return (
        <>
        <Hero/>
        </>
    )
}

export default SupportPage
